
import React, { Component } from 'react';

import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Link from '@material-ui/core/Link';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import ErrorMessage from './cmpErrorMessage'
import DtmcLTL from './cmpDtmcLtl'

export default class Benchmarks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      results: undefined,
      failedMsg: undefined
    };
  }

  componentDidMount() {
    fetch(process.env.PUBLIC_URL + '/benchmarks/results.json')
      .then(response => {
        if (!response.ok)
          throw Error('./' + response.statusText);
        return response;
      })
      .then((r) => r.json())
      .then(js => {
        this.setState({
          isLoading: false,
          results: js.files
        })
      })
      .catch(e => this.setState({
        isLoading: false,
        failedMsg: e
      }))
  }

  transform = (result, index) => {
    const file = result.file;
    return (
      <ExpansionPanel key={index} defaultExpanded={!index} TransitionProps={{ unmountOnExit: true }}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{ backgroundColor: '#EEEEEE' }}>
          <Typography>
            <b>{file.type}: {file.name}</b>
            {!file.link ? '' : <br />}
            {!file.link ? '' : <Link target='_blank' rel='noreferrer' href={file.link} >{file.link_name ? file.link_name : file.link}</Link>}
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <DtmcLTL address={process.env.PUBLIC_URL + file.address} />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    )
  }

  render = () => {
    return (
      <Typography component="div" papers={this.state.papers} style={{ padding: 8 * 3 }}>
        {
          this.state.failedMsg ? <ErrorMessage msg={'Error in loading benchmark results file.'} extra={this.state.failedMsg.toString()} /> :
            this.state.isLoading ?
              <table style={{ margin: 'auto' }}>
                <tbody>
                  <tr>
                    <td><CircularProgress /></td>
                  </tr>
                </tbody>
              </table> :
              <div width='100%'>
                {this.state.results.map(this.transform)}
              </div>
        }
      </Typography>)
  };
}
